<template>
  <BaseLoading  :spinning="contactListLoading">
    <div class="chat-list-wrap">
      <div class="head-bar">
        <div class="head-title">{{ selectedContactsType }} Contacts</div>
        <div class="options-icon-wrap">
          <a-icon type="search" @click="searchInput" v-if="!searchUser" />
          <a-icon type="close" @click="searchInput" v-if="searchUser" />
          <div class="change-list-options" :class="{ active: !showCheckbox }">
            <a-dropdown placement="bottomRight" :trigger="['click']">
              <a-icon type="ellipsis" />
              <a-menu slot="overlay">
                <a-menu-item v-if="showIgnored || showBlocked || showSaved">
                  <a @click="clearFlags">Active Contacts</a>
                </a-menu-item>
                <a-menu-item v-if="!showSaved">
                  <a @click="enableSaved">Saved List</a>
                </a-menu-item>
                <a-menu-item v-if="!showIgnored">
                  <a @click="enableIgnored">Ignored List</a>
                </a-menu-item>
                <a-menu-item v-if="!showBlocked">
                  <a @click="enableBlocked">Blocked List</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div class="bulk-options" :class="{ active: showCheckbox }">
            <a-dropdown
              placement="bottomRight"
              :trigger="['click']"
              v-if="selectedConversations.length > 0"
            >
              <a-icon type="ellipsis" />
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleMultiIgnore">
                    Delete selected conversations
                  </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <a-checkbox
            :indeterminate="showCheckbox"
            :checked="false"
            @click="toggleShowCheckbox"
          />
        </div>
      </div>
      <div class="search-list-input" :class="{ active: searchUser }">
        <a-input
          placeholder="Search User"
          style="width: 100%"
          allow-clear
          :value="this.query"
          @change="event => onSearchQueryChange(event.target.value)"
          @keyup.enter="handleSearch"
        />
      </div>
      <ul
        class="chat-user-list"
        @scroll="handleContactListScroll"
        v-if="conversations.length !== 0"
      >
        <li
          :class="{
            active:
              selectedConversation &&
              selectedConversation.id === conversation.id,
            unread:
              !conversation.isRead &&
              conversation.lastMessageId &&
              conversation.lastMessageId.msgFrom !== profileId
          }"
          v-for="conversation in conversations"
          :key="conversation.id"
        >
          <div class="conversation">
            <div
              class="user-avatar"
              :class="{
                online: conversation.status && (conversation && conversation.blockBy && conversation.blockBy < 1 ) && !showBlocked && ( conversation.receiverId && !Boolean(senderProfile.uniqueSlug !== 'clubCoach'  && conversation.receiverId.profileType === 'Basic' ))
              }"
              @click="changeUser(conversation)"
            >
              <img
                :src="
                  generateImageUrl(
                    conversation.receiverId.profileImage ||
                      conversation.receiverId.image
                  )
                "
                alt="profile"
              />
            </div>
            <div class="conversation-details" @click="changeUser(conversation)">
              <div class="conversation-name">
                <div class="conversation-name-title">
                  {{
                    conversation.receiverId.coachname ||
                      conversation.receiverId.athletename
                  }}
                </div>
                <div
                  class="conversation-time"
                  :class="{ active: !showCheckbox }"
                >
                  {{
                    conversation.lastConversationDate | convertToFromNowFormat
                  }}
                </div>
              </div>
              <div class="conversation-message">
                <div class="conversation-message-preview">
                  {{ conversation.lastConversation.substr(0, 30) }}
                </div>
              </div>
            </div>
            <div class="user-checkbox" :class="{ active: showCheckbox }">
              <BaseCheckbox
                @change="event => handleConversationCheck(event, conversation)"
              />
            </div>
          </div>
        </li>
      </ul>
      <div class="empty-users" v-if="conversations.length === 0">
        <div class="img-wrap">
          <img src="@/assets/icons/empty_inbox.svg" alt="empty" />
        </div>
        <div class="text-detail">
          <div class="text-title">You don't have any messages yet.</div>
          <div class="text-description">
            Send messages to coaching connections.
          </div>
        </div>
      </div>
    </div>
  </BaseLoading>
</template>

<script>
import { Chat } from "@/models";
import { mapGetters } from "vuex";

const STORE_KEY = "chatStore";

export default {
  name: "ChatList",
  data() {
    return {
      activeKey: 1,
      searchUser: false,
      query: "",
      showBlocked: false,
      showIgnored: false,
      showSaved: false,
      showCheckbox: false,
      selectedConversations: []
    };
  },
  props: {
    selectedConversation: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      contactListLoading: `${STORE_KEY}/contactListLoading`,
      conversations: `${STORE_KEY}/contacts`,
      senderProfile: `${STORE_KEY}/senderProfile`
    }),
    selectedContactsType() {
      if (this.showBlocked) return "Blocked";
      if (this.showIgnored) return "Ignored";
      if (this.showSaved) return "Saved";
      return "Active";
    },
    profileId() {
      return Chat.profileId();
    }
  },
  methods: {
    changeUser(conversation) {
      this.activeKey = conversation.receiverId.Id;
      this.$emit("conversation-clicked", conversation);
    },
    searchInput() {
      this.searchUser = !this.searchUser;
      if (!this.searchUser) {
        this.query = "";
        this.handleSearch();
      }
    },
    onSearchQueryChange(val) {
      this.query = val;
    },
    handleSearch() {
      this.$emit("change-filters", {
        contactIsBlocked: this.showBlocked,
        contactIsIgnored: this.showIgnored,
        isContactSaved: this.showSaved,
        blockBy: this.showBlocked ? this.$route.params.profileId : null,
        q: this.query,
        searchField: "receiverName",
        isConversationCleared: this.query ? null : false
      });
    },
    enableBlocked() {
      this.showBlocked = true;
      this.showIgnored = null;
      this.showSaved = null;
      this.$emit("change-filters", {
        contactIsBlocked: true,
        blockBy: this.$route.params.profileId,
        contactIsIgnored: null,
        isContactSaved: null
      });
      this.$emit("clear-conversation");
      this.selectedConversations = [];
    },
    enableIgnored() {
      this.showIgnored = true;
      this.showBlocked = null;
      this.showSaved = null;
      this.$emit("change-filters", {
        contactIsIgnored: true,
        contactIsBlocked: null,
        blockBy: null,
        isContactSaved: null
      });
      this.$emit("clear-conversation");
      this.selectedConversations = [];
    },
    enableSaved() {
      this.showSaved = true;
      this.showIgnored = null;
      this.showBlocked = null;
      this.$emit("change-filters", {
        contactIsBlocked: null,
        contactIsIgnored: null,
        blockBy: null,
        isContactSaved: true
      });
      this.$emit("clear-conversation");
      this.selectedConversations = [];
    },
    clearFlags() {
      this.showIgnored = false;
      this.showBlocked = false;
      this.showSaved = false;
      this.$emit("change-filters", {
        contactIsBlocked: false,
        blockBy: null,
        contactIsIgnored: false,
        isContactSaved: false
      });
      this.$emit("clear-conversation");
      this.selectedConversations = [];
    },
    clearLabels() {
      this.showIgnored = false;
      this.showBlocked = false;
      this.showSaved = false;
      this.selectedConversations = [];
    },
    handleConversationCheck(event, conversation) {
      event.stopPropagation();
      const existingConversation = this.selectedConversations.find(
        conv => conv.userContactId === conversation.id
      );
      if (existingConversation)
        this.selectedConversations.splice(
          this.selectedConversations.indexOf(existingConversation),
          1
        );
      else
        this.selectedConversations.push({
          userContactId: conversation.id,
          room: [conversation.senderId, conversation.receiverId.Id]
            .sort()
            .join(""),
          senderId: conversation.senderId
        });
    },
    async handleMultiIgnore() {
      await this.$store.dispatch(`${STORE_KEY}/deleteMultipleConversations`, {
        contactList: this.selectedConversations
      });
      this.selectedConversations.forEach(conv =>
        this.$store.dispatch(
          `${STORE_KEY}/deleteContactById`,
          conv.userContactId
        )
      );
      this.selectedConversations = [];
      this.showCheckbox = !this.showCheckbox;
      this.$emit("clear-conversation");
    },
    handleContactListScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        this.$emit("scroll-bottom");
      }
    },
    toggleShowCheckbox() {
      this.selectedConversations = [];
      this.showCheckbox = !this.showCheckbox;
    },
    hideContactSearch() {
      this.query = "";
      this.searchUser = false;
      this.$emit("change-filters", {
        contactIsBlocked: this.showBlocked,
        contactIsIgnored: this.showIgnored,
        isContactSaved: this.showSaved,
        blockBy: this.showBlocked ? this.$route.params.profileId : null,
        q: this.query,
        searchField: "receiverName",
        isConversationCleared: this.query ? null : false
      });
    }
  }
};
</script>

<style lang="scss">
.chat-list-wrap {
  border: 1px solid #dadce0;
  display: flex;
  flex-direction: column;
  position: relative;
  .head-bar {
    position: relative;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    background: #293084;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    height: 56px;
    .head-title {
      color: #ffffff;
      font-size: 15px;
      font-weight: 500;
    }
    .options-icon-wrap {
      display: flex;
      align-items: center;
      .anticon {
        color: #ffffff;
        padding: 8px;
        cursor: pointer;
        border-radius: 50%;
        overflow: hidden;
        transition: all 0.2s linear;
        &:last-child {
          margin-right: 0;
          // border: 1px solid white;
          // border-radius: 50%;
        }
        &:hover {
          background: #ffffff;
          color: #949aa2;
        }
        &.anticon-search {
          margin-right: 5px;
        }
      }
      .change-list-options,
      .bulk-options {
        margin-right: 10px;
        display: none;
        &.active {
          display: block;
        }
      }
    }
  }
  .search-list-input {
    position: relative;
    width: 100%;
    padding: 0 15px;
    background: #293084;
    opacity: 0;
    height: 0;
    transition: all 0.2s ease-in-out;
    input {
      margin: 10px 0;
      height: 32px !important;
      font-size: 12px;
    }
    &.active {
      opacity: 1;
      height: 52px;
    }
  }
  .chat-user-list {
    padding: 0;
    margin: 0;
    list-style: none;
    height: calc(100vh - 150px);
    min-height: 390px;
    overflow-y: scroll;
    li {
      cursor: pointer;
      background: #ffffff;
      transition: all 0.2s linear;
      position: relative;
      &::before {
        content: "";
        display: block;
        height: 100%;
        width: 0;
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        background: #4c55b3;
        opacity: 0;
        transition: all 0.2s linear;
      }
      .conversation {
        display: flex;
        align-items: center;
        flex-basis: 100%;
        padding: 15px 20px;
        border-bottom: 1px solid #f1f3f5;
        .user-avatar {
          margin-right: 1rem;
          height: 50px;
          width: 50px;
          overflow: visible;
          position: relative;
          &::after {
            content: "";
            display: inline-block;
            position: absolute;
            opacity: 0;
            top: 0;
            right: 0;
            z-index: 0;
            height: 0.8125rem;
            width: 0.8125rem;
            border-radius: 6.25rem;
            border: 2px solid #ffffff;
          }
          &.online {
            &::after {
              opacity: 1;
              background: #28a745;
            }
          }
          img {
            border-radius: 50%;
          }
        }
        .conversation-details {
          font-weight: 500;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          width: calc(100% - 60px);
          .conversation-name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 2px;
            .conversation-name-title {
              font-weight: 500;
              color: #3e4247;
              text-overflow: ellipsis;
              display: -webkit-box;
              font-size: 14px;
              padding-right: 15px;
              -webkit-line-clamp: 1;
              overflow: hidden;
              -webkit-box-orient: vertical;
            }
            .conversation-time {
              font-size: 0.75rem;
              color: #acb6d1;
              display: none;
              &.active {
                display: block;
              }
            }
          }
          .conversation-message {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .conversation-message-preview {
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 12px;
              color: #a2a2a2;
              padding-right: 10px;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              width: calc(100% - 20px);
            }
            .unread {
              font-size: 10px;
              color: #ffffff;
              width: 18px;
              height: 18px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              background: #d73228;
            }
          }
        }
        .user-checkbox {
          position: absolute;
          top: 12px;
          right: 8px;
          display: none;
          &.active {
            display: block;
          }
        }
      }
      &.active {
        background: #f1f1f1;
        &::before {
          opacity: 1;
          width: 6px;
        }
      }
      &.unread {
        .conversation {
          .conversation-details {
            .conversation-name {
              .conversation-name-title {
                color: #000000;
                font-weight: bold;
              }
            }
            .conversation-message {
              .conversation-message-preview {
                color: #000000;
                font-weight: bold;
              }
            }
          }
        }
      }
      &:hover {
        background-color: #f9f4fd;
      }
    }
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #cacacc;
      outline: none;
    }
  }
  .empty-users {
    height: calc(100vh - 150px);
    min-height: 390px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img-wrap {
      width: 100%;
      max-width: 300px;
      padding: 0 20px 30px;
    }
    .text-detail {
      text-align: center;
      padding: 0 20px;
      .text-title {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        padding-bottom: 10px;
      }
      .text-description {
        font-size: 14px;
        font-weight: 400;
        color: #565656;
      }
    }
  }
}
</style>
